/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{508FFB34-1127-4AA9-B90F-B0FC33A4A6DF}",
  "sitecoreApiHost": "https://www.cochlear.com",
  "jssAppName": "support",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/support",
  "graphQLEndpoint": "https://www.cochlear.com/api/support?sc_apikey={508FFB34-1127-4AA9-B90F-B0FC33A4A6DF}"
};